<template>
  <div>
    <div class="form-container ou-donation-form jlic-donation-form jlicformlg">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
      <FormRow>
                            <LazyCurrencySelector :currencies="['ILS', 'USD']" />
                        </FormRow>          
            <AmountSelectorList/>
            <ErrorLabel field="amount" />
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <DonationFrequency />
          </FormSection>
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
            </FormRow>
<FormRow inline>
              <div>
                <FormLabel class="control-label">
                  Designation:
                </FormLabel>
                <FormInput type="text" class="width-half" field="custom.Notes" />
              </div>
            </FormRow>            
            <FormRow>
              <FormLabel>
                <input type="checkbox" field="custom.contactMe" :checked="contactMe" @click="contactMe = $event.target.checked" /> Would you like us to contact you regarding
                naming opportunities?
              </FormLabel>
            </FormRow>
            <InHonorOf />
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
            <Receipt :receipts="['us', 'israel']"/>
          </FormRow>
          <br>          
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    const contactMe = ref();

    watch(contactMe, () => {
      if (contactMe.value) {
        setValue("custom.contactMe", contactMe.value);
      }
    });
    return {
      form,
      contactMe,
      setValue,
    };
  },
});
</script>

<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
::v-deep span.flex > span {
    display: flex;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container .radio-part {
  @media (min-width: 720px) {
    min-width: 22.6%;
    max-width: 22.6%;
  }
}

::v-deep input#inHonorOf {
    margin-top: -3px;
}

::v-deep input#amount_other {
  margin-left: auto !important;
    font-size: 14px !important;
    padding-bottom: 0px !important;
    max-width: 227px !important;
    width: 100%;
}
</style>
